import { useFormik } from "formik";
import { useContext, useState } from "react";
import { mapStates } from "../../../constants/mapRegions";

import { Context } from "../../../context/context";
import LeadService from "../../../services/leadService";
import { validLeadConvert } from "../../../services/leadValidation";
import sessionTracking from "../../../services/sessionTracking";
import { sendAnalytics } from "../../../utils/analyticsCommon";

const useBookingFormReferal = () => {
  const state = useContext(Context);
  const { showSnackbar } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const form = useFormik({
    validateOnChange: true,
    initialValues: {
      name: "",
      mobile: "",
      referalNumber: "",
      state: "none",
    },

    validate: (values) => {
      const errors = {};

      if (!values?.mobile?.toString()) {
        errors.mobile = "Mobile Number is Mandatory";
      }
      if (values?.mobile?.toString()?.length !== 10) {
        errors.mobile = "Enter a valid 10 digit Mobile Number";
      }
      if (!values?.referalNumber?.toString()) {
        errors.referalNumber = "Mobile Number is Mandatory";
      }
      if (values?.referalNumber?.toString()?.length !== 10) {
        errors.referalNumber = "Enter a valid 10 digit Mobile Number";
      }

      if (values?.referalNumber?.toString() === values?.mobile?.toString()) {
        errors.referalNumber = "Please enter different number";
      }

      if (values?.state?.length === 0 || values?.state === "none") {
        errors.state = "Please enter a state";
      }

      const ipInformation = localStorage.getItem("geoLocation")
        ? JSON.parse(localStorage.getItem("geoLocation"))
        : {};

      if (values?.mobile?.toString()?.length === 10) {
        let payload = {
          phoneNumber: values?.mobile,
          connectType: "Referral",
          type: "Referral_form",
          cityInfo: ipInformation?.city,
          geoInfo: ipInformation,
        };
        sendAnalytics("v2_lead_form_entered_mobile", payload, "en");

        const leadPayload = {
          name: "",
          phone: values?.mobile,
          state: mapStates[ipInformation?.countryRegion] ?? "Others",
          leadIntent: "HIGH_INTENT",
          subSource: "Referral",
        };

        // param: leadpayload, analyticsPayload
        validLeadConvert(leadPayload, payload);
      }

      return errors;
    },

    onSubmit: (values) => {
      const payloadLead = {
        name: values?.name ?? "",
        phone: values?.mobile,
        language: "en",
        state: values?.state,
        subSource: "Referral",
      };

      const payloadRef = {
        phone: values.referalNumber,
        refNumber: values?.mobile,
        language: "en",
        state: values?.state,
        subSource: "Referral",
      };

      const analytics_payload = {
        name: values?.name ?? "",
        phone: values?.mobile,
        friends_phone: values?.referalNumber,
        vehicle_name: state?.vehicleBrand,
        state: values?.state,
      };
      sendAnalytics("referral_form_submitted", analytics_payload, "en");

      setLoading(true);

      LeadService(payloadLead)
        .then((response) => {
          const sessionInfo = {
            leadUuid: response?.data?.uuid,
            newSession: true,
            formSubmitted: true,
          };

          sessionTracking(sessionInfo);
          LeadService(payloadRef)
            .then((response) => {
              const sessionInfo = {
                leadUuid: response?.data?.uuid,
                newSession: true,
                formSubmitted: true,
                leadIntent: "LOW_INTENT",
              };

              sessionTracking(sessionInfo);
              showSnackbar("Referral added successfully", "success");
              setLoading(false);
              setShowSuccess(true);
            })
            .catch((error) => {
              showSnackbar("Oops, Something went wrong Try Again!!", "error");
            });
        })
        .catch((error) => {
          showSnackbar("Oops, Something went wrong Try Again!!", "error");
        });
    },
  });
  return {
    form,
    loading,
    showSuccess,
  };
};

export default useBookingFormReferal;
